var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_74717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40442 23.1137C6.64785 23.1137 4.96322 22.4678 3.72113 21.3182C2.47905 20.1686 1.78125 18.6093 1.78125 16.9834C1.78125 15.3576 2.47905 13.7983 3.72113 12.6487C4.96322 11.499 6.64785 10.8532 8.40442 10.8532C8.81929 9.06475 10.0329 7.49309 11.7784 6.48395C12.6427 5.98428 13.6115 5.63775 14.6295 5.46415C15.6475 5.29054 16.6949 5.29327 17.7117 5.47217C18.7285 5.65106 19.6949 6.00263 20.5558 6.50679C21.4166 7.01095 22.1549 7.65784 22.7287 8.41051C23.3024 9.16318 23.7004 10.0069 23.8997 10.8935C24.099 11.7801 24.0959 12.6922 23.8905 13.5777H25.2983C26.6051 13.5777 27.8584 14.0801 28.7825 14.9743C29.7066 15.8684 30.2257 17.0812 30.2257 18.3457C30.2257 19.6103 29.7066 20.823 28.7825 21.7172C27.8584 22.6114 26.6051 23.1137 25.2983 23.1137H23.8905",
    stroke: "#9FA6B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20L16 16L20 20",
    stroke: "#9FA6B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16V28",
    stroke: "#9FA6B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_74717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.2b675bc207fc17a2358a84e7861ffb1e.svg";
export { ForwardRef as ReactComponent };